import { render, staticRenderFns } from "./SuspendLineDateFields.vue?vue&type=template&id=14d387f8&scoped=true&"
import script from "./SuspendLineDateFields.vue?vue&type=script&lang=js&"
export * from "./SuspendLineDateFields.vue?vue&type=script&lang=js&"
import style0 from "./SuspendLineDateFields.vue?vue&type=style&index=0&id=14d387f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d387f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
